import { useState } from 'react';
import { faqs } from '@/mocks/articles';
import SectionHeading from '@/components/base/SectionHeading';

export default function HomeFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section aria-label="常见问题" className="mx-auto mt-16 w-full max-w-[1280px] px-4 md:mt-20 md:px-6">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.4fr]">
        <SectionHeading
          eyebrow="常见问题"
          title="关于看料99，你可能想知道的"
          desc="我们把读者问得最多的问题整理在这里，如果还有疑问，欢迎通过邮箱联系我们。"
        />
        <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">{item.q}</span>
                  <i
                    className={`shrink-0 text-lg text-primary-500 transition-transform ${
                      isOpen ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}